module.exports = __webpack_public_path__ + "static/media/views.a228a7ad.svg";